import { hero } from "@/mocks/gossip";
import { scrollToId } from "@/lib/scroll";

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden">
      {/* 背景装饰 */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 -top-24 h-80 w-80 rounded-full bg-brand-100/70 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-gold-100/60 blur-3xl"
      />

      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-5 px-4 py-8 md:px-6 md:py-10 lg:grid-cols-3">
        {/* 主头条 */}
        <article className="relative overflow-hidden rounded-2xl lg:col-span-2">
          <div className="relative h-[430px] w-full md:h-[520px]">
            <img
              src={hero.image}
              alt="顶流剧组档期暗战开机礼内幕 吃瓜前线独家首发加急"
              title="顶流剧组档期暗战内幕 独家抢先首发"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10" />
          </div>

          <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-brand-500 px-2.5 py-1 text-[12px] font-bold tracking-wide text-white">
                <i className="ri-flashlight-fill" />
                {hero.tag}
              </span>
              <span className="rounded-full bg-white/15 px-2.5 py-1 text-[12px] font-medium text-white backdrop-blur">
                {hero.category}
              </span>
            </div>
            <h1 className="mt-3 font-heading text-[24px] font-black leading-snug text-white md:text-[36px] md:leading-tight">
              {hero.title}
            </h1>
            <p className="mt-3 hidden max-w-3xl text-[14px] leading-relaxed text-white/85 md:block md:text-[15px]">
              {hero.lead}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2">
              <span className="text-[12px] text-white/70">{hero.meta}</span>
              <span className="inline-flex items-center gap-3 text-[12px] font-medium text-white/80">
                <span>
                  <i className="ri-eye-line mr-1" />
                  {hero.stats.read}
                </span>
                <span>
                  <i className="ri-chat-3-line mr-1" />
                  {hero.stats.discuss}
                </span>
              </span>
              <button
                onClick={() => scrollToId("exclusive")}
                className="ml-auto whitespace-nowrap rounded-lg bg-white px-4 py-2 text-[13px] font-semibold text-brand-700 transition-colors hover:bg-brand-50"
              >
                继续深挖 <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </article>

        {/* 右栏 · 关联热瓜 */}
        <aside className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <h2 className="font-heading text-[17px] font-bold text-[#241b13]">抢鲜情报 · 关联热瓜</h2>
            <span className="rounded-full bg-brand-50 px-2.5 py-1 text-[11px] font-semibold text-brand-700">
              编辑部推荐
            </span>
          </div>
          <div className="flex flex-col divide-y divide-stone-200 rounded-2xl border border-stone-200 bg-white px-1">
            {hero.related.map((r, i) => (
              <a
                key={r}
                href="#exclusive"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("exclusive");
                }}
                className="group flex items-center gap-3 px-4 py-4"
              >
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-stone-100 font-heading text-[13px] font-black text-stone-400 group-hover:bg-brand-500 group-hover:text-white">
                  {i + 1}
                </span>
                <span className="text-[14px] font-medium leading-snug text-stone-700 group-hover:text-brand-700">
                  {r}
                </span>
                <i className="ri-arrow-right-s-line ml-auto text-stone-300 group-hover:text-brand-500" />
              </a>
            ))}
          </div>

          <div className="relative overflow-hidden rounded-2xl bg-[#241b13] p-5">
            <p className="text-[13px] font-semibold tracking-wide text-gold-300">吃瓜前线速递</p>
            <p className="mt-2 font-heading text-[19px] font-bold leading-snug text-white">
              订阅每日速递，刷新越快料越足，一线新瓜不错过
            </p>
            <button
              onClick={() => scrollToId("newsletter")}
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-lg bg-brand-500 px-4 py-2 text-[13px] font-semibold text-white hover:bg-brand-600"
            >
              立即订阅 <i className="ri-send-plane-fill" />
            </button>
          </div>
        </aside>
      </div>
    </section>
  );
}